import { render, staticRenderFns } from "./_navi-left.vue?vue&type=template&id=6caa0cb0&scoped=true"
import script from "./_navi-left.vue?vue&type=script&lang=js"
export * from "./_navi-left.vue?vue&type=script&lang=js"
import style0 from "./_navi-left.vue?vue&type=style&index=0&id=6caa0cb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6caa0cb0",
  null
  
)

export default component.exports